import React from 'react';
import Classes from './Review.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import ReactStars from 'react-rating-stars-component';
import { useGoogleRating, formatRating, formatCount } from '../../../../../utils/googleRating';

/* ─────────  dummy data  ───────── */
const reviews = [
    {
        name: "Jonathan D. Rausch",
        date: "a month ago",
        rating: 5,
        text: "Our ice maker in our GE Cafe fridge stopped working. We use it frequently and this was an issue for us. We simply called Bruno F and his company. They came right out. Ordered parts. Made repairs. All good now. We would 110% recommend them …",
    },
    {
        name: "Clare Morley",
        date: "a week ago",
        rating: 5,
        text: "I really appreciate the honest assessment by Quick Vents. And Bruno gave us some excellent tips about our washing machine. It was also very easy to schedule an appointment. Bruno came out the very next day and was punctual, professional, …",
    },
    {
        name: "Dominick Rivera",
        date: "a month ago",
        rating: 5,
        text: "I’ve had the pleasure of working with Bruno from Quick Vents on a couple of installs and repairs across my properties, and I couldn’t be happier with the experience. From the moment I reached out, Bruno responded right away, scheduled …",
    },
    {
        name: "Rob Boris",
        date: "3 months ago",
        rating: 5,
        text: "Quick Vents is hands-down the BEST around. Amazing service and company. Our washer/dryer broke and we needed an emergency fix. We scheduled an appointment and right away, Bruno was able to diagnose the issue and fix it fast! Our …",
    },
    {
        name: "Steven Stark",
        date: "3 months ago",
        rating: 5,
        text: "Called Quick Vents on a Saturday and received a call back within 15 minutes from the owner, Bruno. We scheduled a service call for Monday, and Bruno and Zak arrived right on time at 8:00 am. Bruno immediately got on the roof to clear the …",
    },
    {
        name: "Warren Moen",
        date: "a month ago",
        rating: 5,
        text: "Very professional service. Bruno Fraga who made the call was very professional and performed required tasks. He checked out other appliances which were not on the list to insure all were …",
    },
    {
        name: "Melissa Gerstin",
        date: "2 weeks ago",
        rating: 5,
        text: "I have used Quick Vents for many years for cleaning out my dryer vent as well as for appliance repair. Bruno responds quickly, shows up right away, and does great work. I highly recommend Bruno and Quick Vents!",
    },
    {
        name: "Stacey Rook",
        date: "a month ago",
        rating: 5,
        text: "I am so happy I found this company. I’ve had my dryer vents vacuumed by three different people and two appliance companies come out and my dryer was still taking over three hours to dry this company. Diagnosed the problem with my vents and …",
    },
    {
        name: "Craig Connor",
        date: "a month ago",
        rating: 5,
        text: "Terrific service. Taras was very informative and solved the problem with my dryer. He was fast and prompt. Arrived on time and made sure everything was in working order before he left. I would highly recommend and continue to use them for …",
    },
    {
        name: "Larry Schott",
        date: "2 months ago",
        rating: 5,
        text: "Glad I was referred by a neighbor. Bruno answered immediately and sent someone over the nxt day. Parts had to be ordered but they came in within a day and the repair was done the next morning, which was a Sunday (with no xtra weekend …",
    },
    {
        name: "R FG",
        date: "4 months ago",
        rating: 5,
        text: "Bruno was prompt, professional and extremely knowledgeable! Hard to find honest businesses these days and Bruno was very trustworthy. Will definitely be keeping him on my provider list. Definitely would recommend him to family and friends!",
    },
    {
        name: "salva 224",
        date: "5 months ago",
        rating: 5,
        text: "Bruno does excellent work and so far he has separately repaired my dishwasher, refrigerator freezer and dryer. The work done by Bruno and his staff is reliable, first rate and affordable. I have full confidence in him because he shows up …",
    },
    {
        name: "Mr Rel",
        date: "Edited 3 months ago",
        rating: 5,
        text: "Used them for the first time today. Excellent communication. Service man arrived on time. He was able to diagnose problem and offer a very fair price to repair dryer. Replaced the heating element and didn't try to upset any Service. Very honest and trustworthy company. Do not hesitate to use them.",
    },
    {
        name: "Nirit Swerdloff",
        date: "a month ago",
        rating: 5,
        text: "Great experience. Called and able to get appointment the following day. Excellent service. Zachary was on time, professional and knowledgeable. Dryer vent cleaned for a fair price. Thanks Quick Vents.",
    },
    {
        name: "Allen Laurie",
        date: "2 months ago",
        rating: 5,
        text: "Our dryer stopped heating. Called a few companies but Bruno was the only who had the part in stock and was able to come almost immediately on a Saturday. Also cleaned out the dryer vent. Had no idea it can be so dirty. Would definitely …",
    },
    {
        name: "Debra Korner",
        date: "4 weeks ago",
        rating: 5,
        text: "Bruno and his team took the time to properly identify the problem and repair our refrigerator saving us a costly replacement. He was responsive and completed the repairs in a timely manner. We highly recommend Bruno. …",
    },
    {
        name: "Randy Brandon",
        date: "4 months ago",
        rating: 5,
        text: "It’s rare to actually rave about a service company these days . Last night as water was pouring out of my LG frig, a friend gave me Bruno at Quick Vents to call. It was 9pm. Bruno not only called me back at that hour but was calm and …",
    },
    {
        name: "Irene M",
        date: "9 months ago",
        rating: 5,
        text: "I found this company online and called for emergency repair of my washer, the appt setting was easy, they dx issue correctly and since he was here we discussed the importance of dryer vent cleaning, he was busy but I liked our initial …",
    },
    {
        name: "Rob Gluckin",
        date: "a month ago",
        rating: 5,
        text: "Bruno is great. I would recommend him to everyone. He communicates with you every step of the way and gets the work done fast. …",
    },
    {
        name: "Paul Murray",
        date: "2 months ago",
        rating: 5,
        text: "Great experience! Came out quickly, was very efficient, and the technician could not have been nicer. He explained the issue, told me exactly what he was doing, was very thorough with everything he did and then told me what I needed to do …",
    },
];

/* ─────────  single review card ───────── */
function ReviewCard({ review }) {
    const initial = review.name.trim().charAt(0).toUpperCase();

    return (
        <div className={Classes.card}>
            {/* stars + Google mark */}
            <div className={Classes.cardTop}>
                <span className={Classes.cardStars} aria-label={`${review.rating} out of 5 stars`}>
                    {[0, 1, 2, 3, 4].map((i) => (
                        <svg key={i} viewBox="0 0 20 20" aria-hidden="true" className={i < review.rating ? "" : Classes.starOff}>
                            <path d="M10 1.5l2.6 5.3 5.9.9-4.25 4.1 1 5.8L10 14.9l-5.25 2.7 1-5.8L1.5 7.7l5.9-.9z" />
                        </svg>
                    ))}
                </span>
                <img src="/assets/icons/google.png" alt="Google review" className={Classes.gIcon} />
            </div>

            {/* review text */}
            <p className={`${Classes.text} ${Classes.reviewText}`}>“{review.text}”</p>

            {/* reviewer */}
            <div className={Classes.reviewer}>
                <span className={Classes.avatar} aria-hidden="true">{initial}</span>
                <span>
                    <h4 className={Classes.name}>{review.name}</h4>
                    <p className={Classes.date}>{review.date}</p>
                </span>
            </div>
        </div>
    );
}

/* ─────────  main section ───────── */
export default function Review() {
    const googleRating = useGoogleRating();
    return (
        <section className={Classes.wrapper} id="testimonials">
            <p className={Classes.miniText}>Testimonials</p>
            <h2 className={Classes.subheading}>
                Top Rated in South Florida
            </h2>

            <div className={Classes.ratingRow}>
                <ReactStars
                    value={5}
                    count={5}
                    size={24}
                    edit={false}
                    isHalf={false}
                    activeColor="#FFD700"
                />
                <p className={Classes.text}>{formatRating(googleRating.rating)} Rating of {formatCount(googleRating.count)} Reviews</p>
            </div>

            {/* Swiper carousel (arrows sit outside it so the slider only needs a small shadow gutter) */}
            <div className={Classes.slider}>
            <Swiper
                className={Classes.swiper}
                modules={[Navigation, Autoplay]}
                navigation={{
                    nextEl: `.${Classes.next}`,
                    prevEl: `.${Classes.prev}`,
                }}
                loop
                autoplay={{ delay: 4500, disableOnInteraction: false }}
                spaceBetween={40}
                slidesPerView={1}
                breakpoints={{
                    640: { slidesPerView: 1.25 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
            >
                {reviews.map((r, i) => (
                    <SwiperSlide key={i}>
                        <ReviewCard review={r} />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* navigation arrows */}
            <div className={Classes.prev} role="button" aria-label="Previous review">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
            </div>
            <div className={Classes.next} role="button" aria-label="Next review">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
            </div>
            </div>

            {/* “View all” button */}
            <a className={Classes.viewAllLink} target='_blank' rel='noreferrer' href='https://www.google.com/search?sca_esv=9d29c1b39aeb3b2c&sxsrf=AE3TifMaBqRf5AKUiFeM8Vb5HZ_KN29MzA:1765567956756&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E6zUa0jXJ_omAWzkDR1rfn_RR1OCAEf_BXDQDj5ypC39TJFEFzQ_teJaQr29N3yWltyeH4XzVStnHtHzhhS0ynE6ZByfIjM7mAX46F3Du-7DUYC2xg%3D%3D&q=Quick+Vents+%2B+Appliance+Repair+Reviews&sa=X&ved=2ahUKEwjhp46X5biRAxXsgP0HHdFDNdQQ0bkNegQIJhAE&biw=1707&bih=811&dpr=1.13' >
                <button className={Classes.viewAll}>View all reviews</button>
            </a>
        </section>
    );
}
